<template>
  <!-- 类名qs-ellipsis-tooltip不要删除 -->
  <div v-show-tooltip class="qs-ellipsis-tooltip wp100">
    <a-tooltip :content="sContent" :position="props.position">
      <div
        class="overflow-ellipsis"
        :class="textClass"
        :style="{ '-webkit-line-clamp': line }"
      >
        <slot name="prefix"></slot>
        {{ content }}
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  const props = defineProps({
    content: {
      type: [String, Number],
      default: '',
    },
    // 默认超过3行截断文本并提示
    line: {
      type: [Number, String],
      default: 3,
    },
    textClass: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'bottom',
    },
  });
  // 兼容content为数值型变量的情况
  const sContent = computed(() => {
    return props.content.toString();
  });
</script>

<script lang="ts">
  export default {
    // 用于文本超过多少行自动截断并且hover时tooltip提示
    name: 'EllipsisTooltip',
  };
</script>

<style lang="less" scoped>
  .overflow-ellipsis {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    line-break: anywhere;
  }
</style>
